import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { LanguageService } from '@shared/services/language.service';
import { TrackingService } from '@shared/services/tracking.service';
import { CH_LIST_OF_HOLIDAYS, DE_IDNOW_HOLIDAYS, DE_OTHER_HOLIDAYS } from 'src/app/app.constants';

import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-dialog-book-consultation',
  templateUrl: './dialog-book-consultation.component.html',
  styleUrls: ['./dialog-book-consultation.component.scss'],
  standalone: false
})
export class DialogBookConsultationComponent {
  @Input() appLocation = 'ch';
  @Input() accountId: number;
  @Output() bookModal = new EventEmitter<boolean>();

  date: Date;
  day: string;
  timeIndex = 0;
  timesArray = [];
  callType = 'video';
  consultationPhone = '';
  consultationNote = '';
  success = false;
  submitted = false;
  isInvalid = false;
  currentLang: string;
  loading = false;
  firstAvailableDate: Date;
  newDate = new Date();
  showBackButton = false;

  constructor(
    private languageService: LanguageService,
    public http: HttpClient,
    private trackingService: TrackingService
  ) {
    this.currentLang = this.languageService.getRedirectLanguage();
    this.findFirstAvailableDate();
  }

  findFirstAvailableDate(): void {
    this.date = new Date();
    const day = this.date.getDay();

    switch (day) {
      case 0:
        // first avaiable is 48 hours (2 day) later day, hour, min, sec, milisec
        this.firstAvailableDate = new Date(Date.now() + 2 * 24 * 60 * 60 * 1000);
        break;
      case 6:
        // first avaiable is 72 hours (3 day) later day, hour, min, sec, milisec
        this.firstAvailableDate = new Date(Date.now() + 3 * 24 * 60 * 60 * 1000);
        break;
      case 5:
        // first avaiable is 96 hours (4 day) later day, hour, min, sec, milisec
        this.firstAvailableDate = new Date(Date.now() + 4 * 24 * 60 * 60 * 1000);
        break;
      default:
        // first avaiable is 36 hours (1.5 day) later day, hour, min, sec, milisec
        this.firstAvailableDate = new Date(Date.now() + 1.5 * 24 * 60 * 60 * 1000);
        break;
    }

    // it's too late so add one more day
    if (this.firstAvailableDate.getHours() >= 18) {
      this.firstAvailableDate.setDate(this.firstAvailableDate.getDate() + 1);
      this.firstAvailableDate.setHours(10, 0, 0);
    }

    // check the firstavilable date hours is acceptable
    if (this.firstAvailableDate.getHours() < 10) {
      this.firstAvailableDate.setHours(10, 0, 0);
    }

    const firstAvailableDay = this.firstAvailableDate.getDay();
    // if the day is satuday add 2 days more
    if (firstAvailableDay === 6) {
      this.firstAvailableDate.setDate(this.firstAvailableDate.getDate() + 2);
    }

    // SET DATE proper date, hours
    this.date = this.firstAvailableDate;
    this.setDateFormat(0);
    this.halfHourTimes();
  }

  close(): void {
    this.trackCTA('Consultation modal => Close');
    this.bookModal.emit(false);
  }

  otherDay(val: number): void {
    this.newDate = new Date(this.date);
    this.newDate.setDate(this.newDate.getDate() + val);
    const newDay = this.newDate.getDay();

    if (newDay === 6 || newDay === 0) {
      this.newDate.setDate(this.newDate.getDate() + 2 * val);
    }

    this.date = new Date(this.newDate);
    this.setDateFormat(val);

    this.showBackButton = !this.checkPastDay();

    this.halfHourTimes();
  }

  otherTime(val: number): void {
    if (this.timeIndex + val >= 0) {
      this.timeIndex += val;
      // no booking time during lunch
      if (this.timesArray[this.timeIndex] === '12:00') {
        this.timeIndex += 2;
      }
      if (this.timesArray[this.timeIndex] === '12:30') {
        this.timeIndex -= 2;
      }
    } else {
      this.timeIndex = 0;
    }
  }

  checkHoliday(day: string, direction: number): void {
    if (!day || !direction) {
      return;
    }

    const listOfDays = this.appLocation === 'ch' ? CH_LIST_OF_HOLIDAYS : [...DE_IDNOW_HOLIDAYS, ...DE_OTHER_HOLIDAYS];
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access

    // english date Wednesday, 16/07/2021 -  // german date - Mittwoch, 24.2.2021 // french date - mercredi, 24/02/2021
    const daySeperator = ',';
    const dateSeperator = this.currentLang === 'en' ? '/' : '.';
    let dayString = day.toLocaleString().split(daySeperator)[1].trim();

    const splitedDay = dayString.split(dateSeperator);
    let dayValue = splitedDay[0];
    let monthValue = splitedDay[1];

    if (dayValue.length === 1) {
      dayValue = `0${dayValue}`;
    }

    if (monthValue.length === 1) {
      monthValue = `0${monthValue}`;
    }

    dayString = `${monthValue}/${dayValue}/${splitedDay[2]}`;

    if (listOfDays.includes(dayString)) {
      this.otherDay(direction);
    }
  }

  checkPastDay(): boolean {
    // set the date hours to early hours for past day check
    if (this.date <= this.firstAvailableDate) {
      this.date.setDate(this.firstAvailableDate.getDate());
      this.date.setHours(this.firstAvailableDate.getHours(), this.firstAvailableDate.getMinutes(), this.firstAvailableDate.getSeconds());
    }
    return this.date <= this.firstAvailableDate;
  }

  halfHourTimes(): void {
    this.timesArray = [];
    this.timeIndex = 0;

    const hour = this.date.getHours();

    const minutesInterval = 30;
    let startTime = 10 * 60;
    let endTime = 18 * 60 + 30;

    // friday compass
    if (this.date.getDay() === 5) {
      endTime = 16 * 60 + 30;
    }

    if (this.date <= this.firstAvailableDate) {
      startTime = hour * 60;

      if (startTime >= endTime) {
        this.otherDay(1);
      }
    }

    // monday morning
    if (this.date.getDay() === 1) {
      startTime = 13 * 60;
    }

    for (let i = 0; startTime < endTime; i++) {
      const hh = Math.floor(startTime / 60) % 24;
      const mm = startTime % 60;
      this.timesArray[i] = `${`0${hh}`.slice(-2)}:${`0${mm}`.slice(-2)}`;
      startTime += minutesInterval;
    }
  }

  setDateFormat(direction: number): void {
    const options: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric' };
    const languages = {
      fr: 'fr-CH',
      en: 'en-GB',
      de: 'de-CH'
    };
    this.day = this.date.toLocaleDateString(languages[this.currentLang], options);
    this.checkHoliday(this.day, direction);
  }

  selectedCallType(type: string): void {
    this.callType = type;
    this.consultationPhone = '';
  }

  book(): void {
    const consultationDate = `${this.date.getFullYear()}/${this.date.getMonth() + 1}/${this.date.getDate()}`;
    const consultationTime = this.timesArray[this.timeIndex];
    const consultationType = this.callType.length > 0 ? this.callType : 'video';

    if ((this.callType === 'phone' && this.validPhoneFormat()) || this.callType === 'video') {
      this.loading = true;
      this.http
        .post(`${environment.apiUrl}/accounts/${this.accountId}/strategy/book-consultation`, {
          consultation_date: consultationDate,
          consultation_time: consultationTime,
          consultation_type: consultationType,
          consultation_phone: this.consultationPhone,
          consultation_note: this.consultationNote
        })
        .subscribe(
          (response) => {
            if (response['success']) {
              this.success = true;
              this.trackingService.trackActivity('Consultation modal CTA => Book consultation (success)', true);
            } else {
              this.close();
            }
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    } else {
      this.isInvalid = true;
    }
  }

  validPhoneFormat(): boolean {
    const phone = this.consultationPhone.replace(/\s|-/g, '');
    const regex = this.appLocation === 'ch' ? /^(?=\d{10}$)(0)\d+/ : /^(?=\d{10,13}$)(0)\d+/;
    if (regex.test(phone)) {
      this.isInvalid = false;
      return true;
    }
    this.isInvalid = true;
    return false;
  }

  trackCTA(event: string): void {
    this.trackingService.trackActivity(event, true);
  }
}
